var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 123,
    height: 111,
    viewBox: "0 0 123 111",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M94.8053 21.083H20.1016C18.997 21.083 18.1016 21.9784 18.1016 23.083V96.9997C18.1016 98.1042 18.997 98.9997 20.1016 98.9997H94.8053C95.9098 98.9997 96.8053 98.1042 96.8053 96.9997V23.083C96.8053 21.9784 95.9098 21.083 94.8053 21.083Z",
    fill: "#F1F5FA",
    stroke: "#BCC4D6",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M94.8056 21.083H19.9494C18.8448 21.083 17.9494 21.9784 17.9494 23.083V51.8277C17.9494 64.2732 9.04556 76.574 2.93867 83.8215C1.82436 85.1439 2.74717 87.1941 4.47647 87.1941H77.6281C77.906 87.1941 78.1789 87.14 78.4285 87.0177C88.0002 82.327 94.7823 61.1953 96.763 52.0265C96.7924 51.89 96.8056 51.7573 96.8056 51.6176V23.083C96.8056 21.9784 95.9101 21.083 94.8056 21.083Z",
    fill: "#F1F5FA",
    stroke: "#BCC4D6",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38 17L38 25",
    stroke: "#BCC4D6",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M59 17L59 25",
    stroke: "#BCC4D6",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1016 33.6758L96.8053 33.6758",
    stroke: "#BCC4D6",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M80 17L80 25",
    stroke: "#BCC4D6",
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M51.65 70.39C51.13 70.39 50.72 70.25 50.42 69.97C50.14 69.67 50 69.27 50 68.77C50 68.25 50.14 67.86 50.42 67.6C50.72 67.34 51.13 67.21 51.65 67.21H55.01V52.48H56.87L52.46 55.15C52.08 55.37 51.72 55.46 51.38 55.42C51.06 55.36 50.78 55.22 50.54 55C50.32 54.76 50.17 54.48 50.09 54.16C50.01 53.84 50.03 53.52 50.15 53.2C50.29 52.86 50.55 52.58 50.93 52.36L55.07 49.87C55.47 49.63 55.87 49.43 56.27 49.27C56.67 49.09 57.04 49 57.38 49C57.8 49 58.15 49.12 58.43 49.36C58.71 49.58 58.85 49.95 58.85 50.47V67.21H61.91C62.43 67.21 62.83 67.34 63.11 67.6C63.41 67.86 63.56 68.25 63.56 68.77C63.56 69.29 63.41 69.69 63.11 69.97C62.83 70.25 62.43 70.39 61.91 70.39H51.65Z",
    fill: "#5D6A86"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M81.875 69.875L95.7204 103.108L100.636 88.6358L115.108 83.7204L81.875 69.875Z",
    fill: "white",
    stroke: "#5D6A86",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M101.457 89.458L113.207 101.208",
    stroke: "#5D6A86",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M111.164 8L101.998 15.745",
    stroke: "#5D6A86",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M118 27H106",
    stroke: "#5D6A86",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M89 1L89 13",
    stroke: "#5D6A86",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDate);
export default __webpack_public_path__ + "static/media/date.1f60b98f71331eb428efaf1ca052ade5.svg";
export { ForwardRef as ReactComponent };